/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    variants: {
        underline: {
            textDecoration: 'underline',
            _hover: {
                textDecoration: 'none'
            }
        },
        button: {
            textDecoration: 'none',
            backgroundColor: 'black',
            color: 'white',
            padding: '10px 20px',
            borderRadius: '4px',
            cursor: 'pointer'
        },
        smallBtn: {
            textDecoration: 'none',
            backgroundColor: 'black',
            color: 'white',
            padding: '4px 25px',
            borderRadius: '90px',
            cursor: 'pointer',
            border: 'none',
            fontSize: '14px',
            letterSpacing: '0.07px',
            lineHeight: '22px',
            fontFamily: 'inter',
            fontWeight: '400',
            _hover: {
                backgroundColor: 'black',
                color: 'white'
            }
        }
    }
}
